import { useMutation } from '@tanstack/react-query';
import type { SupportFeedbackRequest, SupportFeedbackResult } from '@repo/shared-types';
import { fetchApi } from '../lib/api';

/** POST /support/feedback — the in-app "Trợ giúp & góp ý" form. Rate-limited
 *  server-side (5/hour per user); the caller distinguishes a 429 from any
 *  other failure by reading `err.status` off the thrown Error (see
 *  fetchApi — it attaches `status` and `code` from the API's error body). */
export function useSupportFeedback() {
  return useMutation<SupportFeedbackResult, Error & { status?: number; code?: string }, SupportFeedbackRequest>({
    mutationFn: (body) =>
      fetchApi<SupportFeedbackResult>('/support/feedback', {
        method: 'POST',
        body: JSON.stringify(body),
      }),
  });
}
